export interface FileConstructionDigest{
    total: number,
    uploaded: number,
    dirCount: number,
}

export interface FileConstructionNode {
    id: number,
    parent_id: number,
    isDummy: boolean,
    name: string,
    isAllLoaded: boolean,
    info: FileConstructionNodeInfo,
    pagination: FileConstructionPagination,
    children: FileConstructionNode[],
    file_type: number,
    file_path: string,
    download_status: number,
    download_link: FileDownloadLink,
    full_path: string,
    ossLink: string,
}


export interface FileDownloadLink {
    url: string,
    pwd: string,
}

export interface FileConstructionNodeInfo {
    size: string,
    date_created: number,
    date_modified: number,
    date_accessed: number,
}

export interface FileConstructionPagination {
    pageSize: number,
    pageNum: number,
}

// path in format: C:/a/b/c/d/e/f/g
export interface FileConstructionState {
    userName: string,
    isUsernameLoading: boolean,
    diskSlice: FileConstructionNode[],
    currentPath: string,
    inputPath: string,
    currentNode: FileConstructionNode,
    fileNodeTree: FileConstructionNode,
    searchNodeTree: FileConstructionNode,
    isLoading: boolean,
    backHistory: string[],
    forwardHistory: string[],
    searchResult: FileConstructionNode[],
    isSearching: boolean,
    downLoadedFile: FileConstructionNode[],
    isDownloadedFileLoading: boolean,
    displayType: number,
    currentDigest: FileConstructionDigest | undefined,
}

export const DisplayTypeEnum = {
    FileList: 0,
    Searching: 1,
    Downloaded: 2,
    Extension: 3,
    Uploaded: 4,
};

export const FileDownloadStatus = {
    Idle: 0,
    Uploaded: 1,
    Downloading: 2,
    Downloaded: 3,
    Failed: 4,
    UploadedToOss: 6,
};

export const FileDownloadStatusTypeEnum = {
    UploadedCollection: "uploaded",
    DownloadedCollection: "downloaded",
};


export enum FileExtensionReg {
    'DOC文档' = '(^((?!\\.)(?!~\\$)(?!\\$)).*?\\.(doc|docx)$)|(^((?!\\.)(?!~\\$)(?!\\$)).*(doc|docx).*\\.(wps|et)$)',
    'PPT演示文稿' = '(^((?!\\.)(?!~\\$)(?!\\$)).*?\\.(ppt|pptx)$)|(^((?!\\.)(?!~\\$)(?!\\$)).*(ppt|pptx).*\\.(wps|et)$)',
    'EXCEL表格' = '(^((?!\\.)(?!~\\$)(?!\\$)).*?\\.(xls|xlsx|csv)$)|(^((?!\\.)(?!~\\$)(?!\\$)).*(xls|xlsx|csv).*\\.(wps|et)$)',
    // '文本文档' = '^[^~$].+\\.(txt)$',
    '文本文档' = '^((?!\\.)(?!~\\$)(?!\\$)).*?\\.txt$',
    'PDF文档' = '^((?!\\.)(?!~\\$)(?!\\$)).*?\\.pdf$',
    '图片' = '^((?!\\.)(?!~\\$)(?!\\$)).*?\\.(jpg|jpeg|png)$',
}
// 